import React from 'react';
import { FadeIn } from './FadeIn';
const products = [{
  id: 1,
  title: 'Menopausia y sexualidad',
  description: 'Una guía para entender los cambios y redescubrir el deseo sin tabúes.',
  color: 'bg-rosa',
  originalPrice: '$45.000',
  price: '$19.000',
  buyLink: 'https://habitandomicuerpo.shop/products/menopausia-y-sexualidad',
  coverImage: 'https://image2url.com/r2/default/files/1775024715984-612be3aa-ae12-479c-bc80-83d1c2104b60.png'
}, {
  id: 2,
  title: 'Vivir con obesidad',
  description: 'Una mirada real sobre habitar un cuerpo que no cumple con lo impuesto.',
  color: 'bg-lila',
  originalPrice: '$45.000',
  price: '$19.000',
  buyLink: 'https://habitandomicuerpo.shop/products/vivir-con-obesidad',
  coverImage: 'https://image2url.com/r2/default/files/1775025609917-19642f06-07a7-4601-99e6-5beeee695c9e.png' // Agregar URL de la portada aquí
}, {
  id: 3,
  title: 'Habitar la depresión',
  description: 'Testimonios reales sobre vivir teniendo depresión activa.',
  color: 'bg-celeste',
  originalPrice: '$45.000',
  price: '$19.000',
  buyLink: 'https://habitandomicuerpo.shop/products/habitar-la-depresion',
  coverImage: 'https://image2url.com/r2/default/files/1775025308976-f3e55e28-0499-4071-a6b7-cd6662dc2c0d.png' // Agregar URL de la portada aquí
}, {
  id: 4,
  title: 'Cambios hormonales siendo adolescente',
  description: 'Todo lo que nadie te explicó sobre tu cuerpo en transformación.',
  color: 'bg-durazno',
  originalPrice: '$45.000',
  price: '$19.000',
  buyLink: 'https://habitandomicuerpo.shop/products/cambios-hormonales-en-la-adolescencia',
  coverImage: 'https://image2url.com/r2/default/files/1775025491677-0999ec13-08fa-49b7-b797-f26106c1e4ad.png' // Agregar URL de la portada aquí
}, {
  id: 6,
  title: 'Sexualidad femenina',
  description: 'Exploración, placer y autoconocimiento desde una perspectiva libre.',
  color: 'bg-rosa',
  originalPrice: '$45.000',
  price: '$19.000',
  buyLink: 'https://habitandomicuerpo.shop/products/sexualidad-femenina',
  coverImage: 'https://image2url.com/r2/default/files/1775026313244-df19599e-2647-44be-82aa-e19c815ebbae.png' // Agregar URL de la portada aquí
}, {
  id: 1,
  title: 'Menopausia y sexualidad',
  description: 'Una guía para entender los cambios y redescubrir el deseo sin tabúes.',
  color: 'bg-rosa',
  originalPrice: '$45.000',
  price: '$19.000',
  buyLink: 'https://habitandomicuerpo.shop/products/menopausia-y-sexualidad',
  coverImage: 'https://image2url.com/r2/default/files/1775024715984-612be3aa-ae12-479c-bc80-83d1c2104b60.png'
}];
export function Products() {
  return <section id="ebooks" className="py-24 md:py-32 bg-blanco" data-id="element-157">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-158">
        <FadeIn className="text-center max-w-3xl mx-auto mb-16" data-id="element-159">
          <h2 className="font-serif text-4xl md:text-5xl text-texto mb-6" data-id="element-160">
            Ebooks para comprender procesos reales del cuerpo femenino
          </h2>
          <p className="font-sans text-lg text-textoSuave" data-id="element-161">
            Material de lectura diseñado con empatía, rigor y sensibilidad para
            acompañarte en cada etapa.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-162">
          {products.map((product, index) => <FadeIn key={product.id} delay={index * 0.1} data-id="element-163">
              <div className="group h-full flex flex-col bg-crema rounded-2xl overflow-hidden shadow-soft hover:shadow-md transition-shadow duration-300 border border-beige/50" data-id="element-164">
                {/* Cover Image or Accent Header */}
                <div className={`h-48 w-full ${product.coverImage ? '' : product.color} relative overflow-hidden`} data-id="element-165">
                  {product.coverImage ? <img src={product.coverImage} alt={`Portada de ${product.title}`} className="w-full h-full object-cover" data-id="element-166" /> : <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-blanco to-transparent" data-id="element-167"></div>}
                </div>

                {/* Content */}
                <div className="p-8 flex flex-col flex-grow" data-id="element-168">
                  <h3 className="font-serif text-2xl text-texto mb-3 group-hover:text-rosa transition-colors" data-id="element-169">
                    {product.title}
                  </h3>
                  <p className="font-sans text-textoSuave mb-4 flex-grow" data-id="element-170">
                    {product.description}
                  </p>

                  {/* Offer Pricing */}
                  <div className="flex items-center gap-2 mb-6" data-id="element-171">
                    <span className="inline-block bg-rosa/80 text-texto text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full" data-id="element-172">
                      Oferta
                    </span>
                    <span className="font-sans text-sm text-textoSuave line-through" data-id="element-173">
                      {product.originalPrice}
                    </span>
                    <span className="font-sans font-bold text-texto text-lg" data-id="element-174">
                      {product.price}
                    </span>
                  </div>

                  <div className="flex flex-col sm:flex-row gap-3 mt-auto" data-id="element-175">
                    <button className="flex-1 py-2.5 px-4 rounded-full border border-texto/20 text-texto font-medium text-sm hover:bg-blanco transition-colors" data-id="element-176">
                      Ver más
                    </button>
                    <a href={product.buyLink} target="_blank" rel="noopener noreferrer" className="flex-1 py-2.5 px-4 rounded-full bg-texto text-crema font-medium text-sm hover:bg-texto/90 transition-colors text-center" data-id="element-177">
                      Comprar
                    </a>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}